import { isDevelopment } from '@app/environment';
import { BaseGraphqlLayer } from '@core/base';
import { SocialService } from '@core/services/social';
import { Inject, Injectable } from '@rxdi/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class UploadService extends BaseGraphqlLayer {
  @Inject(SocialService)
  private socialService: SocialService;

  uploadAttachment(productId: string, files: File[]): Observable<[]> {
    if (!files.length || !productId) {
      return of([]);
    }

    const body = new FormData();
    for (const file of files) {
      body.append('file[]', file);
    }

    return this.socialService
      .getUserRef()
      .pipe(switchMap(async (c) => c?.getIdToken()))
      .pipe(
        switchMap((Authorization) =>
          fetch(
            isDevelopment()
              ? 'http://localhost:9000/upload'
              : 'https://functions.lambforge.com/69aeeb82459996e0cf970884/graphql/upload',
            {
              method: 'POST',
              body,
              headers: {
                Authorization,
                productId,
              },
            }
          )
        ),
        switchMap((file) => file.json())
      );
  }

  uploadCategoryLogo(categoryId: string, file: File): Observable<[]> {
    if (!file || !categoryId) {
      return of([]);
    }

    const body = new FormData();
    body.append('file[]', file);

    return this.socialService
      .getUserRef()
      .pipe(switchMap(async (c) => c?.getIdToken()))
      .pipe(
        switchMap((Authorization) =>
          fetch(
            isDevelopment()
              ? 'http://localhost:9000/upload'
              : 'https://functions.lambforge.com/69aeeb82459996e0cf970884/graphql/upload',
            {
              method: 'POST',
              body,
              headers: {
                Authorization,
                categoryId,
              },
            }
          )
        ),
        switchMap((file) => file.json())
      );
  }

  deleteUpload(fileId: string) {
    return this.mutate({
      mutation: 'delete-file.graphql',
      variables: {
        fileId,
      },
    }).pipe(map((res) => res.data.deleteFile));
  }
}
